import React from "react";
import { Text } from "@networkraildigitalfactory/components";

import Filter from "./Filter/Filter";
import { CircleGo } from "../TableIcons/TableIcons";
import useSelectExport from "../../hooks/adminExport/useSelectExport";
import { AdminExportModal } from "../Modals";
import useAdminExportModal from "../../hooks/modals/useCloseObjectivesModal";
import useUser from "../../hooks/useUser";

import styles from "./AdminExport.module.css";

const pills = ["Objectives", "PDP", "1-2-1s", "Reviews"];

const AdminExport = ({ selectedEmployee, employeeName, employeeNumber }) => {
  const { isModalOpen, toggleModal } = useAdminExportModal();
  const { contentType, selectPill, year, selectYear, setYear } = useSelectExport();
  const contentTypeLC = contentType?.toLowerCase();

  const { isGBR } = useUser(selectedEmployee);

  const clearYearAndSelectPill = (item) => {
    selectPill(item);
    setYear("", "");
  };

  const generatePills = () => {
    return pills.map((item, index) => (
      <button
        key={index}
        className={`${styles.pill} ${contentType === item ? styles.selected : ""}`}
        type="button"
        name={`Select {item} pill`}
        aria-label={`Select {item} pill`}
        onClick={() => clearYearAndSelectPill(item)}
      >
        {item}
      </button>
    ));
  };

  const generateFilter = () => {
    switch (contentType) {
      case "Objectives":
      case "PDP":
        return (
          <Filter
            filterBy="year due"
            yearValue={year}
            onYearChange={selectYear}
            contentType={contentType}
            setYear={setYear}
          />
        );
      case "1-2-1s":
      case "Reviews":
        return (
          <Filter
            filterBy="financial year"
            yearValue={year}
            onYearChange={selectYear}
            contentType={contentType}
            setYear={setYear}
          />
        );
      default:
        return <span className={styles.label}>No content type selected</span>;
    }
  };

  return (
    <div className={styles.wrapper}>
      <Text wrapper="span" type="header" className={styles.header_text}>
        Please select the information you wish to export for this{" "}
        {isGBR ? (
          <div className={`${styles.org_tag} ${styles.gbr_tag}`}>GBRTT</div>
        ) : (
          <div className={`${styles.org_tag} ${styles.nr_tag}`}>Network Rail </div>
        )}
        employee
      </Text>
      <div className={styles.pill_group}>{generatePills()}</div>
      <div className={styles.filter_container}>{generateFilter()}</div>
      <div className={styles.button_row}>
        <button
          className={styles.button_without_bg}
          type="button"
          name={`export {contentTypeLC}`}
          aria-label={`export {contentTypeLC}`}
          onClick={toggleModal}
        >
          <span>export {contentTypeLC}</span>
          <CircleGo />
        </button>
      </div>
      <AdminExportModal
        show={isModalOpen}
        close={toggleModal}
        employeeName={employeeName}
        contentType={contentTypeLC}
        year={year}
        selectedEmployee={selectedEmployee}
        employeeNumber={employeeNumber}
      />
    </div>
  );
};

export default AdminExport;
